export default {
    section: 'Officers',
    name: 'entity-support-officers',
    questionWidth: 4,
    items: [
        {
            type: 'text-field',
            text: 'President',
            name: 'entity-support-officer-president',
            props: {
                label: 'President'
            }
        },
        {
            type: 'text-field',
            text: 'Vice President',
            name: 'entity-support-officer-vice-president',
            props: {
                label: 'Vice President'
            }
        },
        {
            type: 'text-field',
            text: 'Secretary',
            name: 'entity-support-officer-secretary',
            props: {
                label: 'Secretary'
            }
        },
        {
            type: 'text-field',
            text: 'Treasurer',
            name: 'entity-support-officer-treasurer',
            props: {
                label: 'Treasurer'
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/entity-existing/valuation-data/officers.js